<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="center" id="title_page">Voyage of the Damned</h1>
<h3 class="center" style="margin-top:60px;">A Shocking True Story of Hope, Betrayal, and Nazi Terror</h3>
<h3 class="center" style="margin-top:80px;">Gordon Thomas and Max Morgan Witts</h3>
<p class="center" style="margin-top:80px;"><img alt="logo" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?2785f972